import BaseModel from './base';

class Note extends BaseModel {
	create(transactionId, body) {
		return this.post(`/${transactionId}/notes`, { body });
	}

	getAll(transactionId) {
		return this.get(`/${transactionId}/notes`);
	}

	updateOne(transactionId, noteId, body) {
		return this.patch(`/${transactionId}/notes/${noteId}`, { body });
	}

	deleteOne(transactionId, noteId) {
		return this.delete(`/${transactionId}/notes/${noteId}`);
	}
}

export default new Note('/transaction');
